import request from '@/utils/request'

// 按合同查询履约项目
export function getFulfillmentByContractId(contractId) {
  return request({
    url: '/crmFulfillmentProject/detailByContractId',
    method: 'get',
    params: { contractId }
  })
}

// 按合同构成自动生成履约项目
export function autoCreateFulfillment(data) {
  return request({
    url: '/crmFulfillmentProject/autoCreate',
    method: 'post',
    data: data
  })
}

// 手动创建履约项目
export function manualCreateFulfillment(data) {
  return request({
    url: '/crmFulfillmentProject/manualCreate',
    method: 'post',
    data: data
  })
}

// 保存技术采购单附件
export function saveProcurementFiles(data) {
  return request({
    url: '/crmFulfillmentProject/procurementFiles/save',
    method: 'post',
    data: data
  })
}

// 保存采购需求
export function saveProcurementRequirement(data) {
  return request({
    url: '/crmFulfillmentProject/requirement/save',
    method: 'post',
    data: data
  })
}

// 确认采购需求
export function confirmProcurementRequirement(data) {
  return request({
    url: '/crmFulfillmentProject/requirement/confirm',
    method: 'post',
    data: data
  })
}

// 转采购
export function transferProcurementRequirement(id) {
  return request({
    url: `/crmFulfillmentProject/requirement/transfer/${id}`,
    method: 'post'
  })
}

// 作废采购需求
export function cancelProcurementRequirement(id) {
  return request({
    url: `/crmFulfillmentProject/requirement/cancel/${id}`,
    method: 'post'
  })
}

// 删除采购需求
export function removeProcurementRequirement(id) {
  return request({
    url: `/crmFulfillmentProject/requirement/remove/${id}`,
    method: 'post'
  })
}
